import { ca } from '@cian/analytics';

interface ITrackingParams {
  action: string;
  category: string;
  label?: string;
  sc?: object;
  products?: unknown;
  page?: unknown;
}

export function trackMortgagePaymentClick(params: ITrackingParams) {
  ca('eventSite', {
    name: 'oldevent',
    ...params,
  });
}

export function trackMortgagePaymentInfoShow(params: ITrackingParams) {
  ca('eventSite', {
    name: 'oldevent',
    ...params,
  });
}

export function trackMortgagePaymentInfoLinkClick(params: ITrackingParams) {
  ca('eventSite', {
    name: 'oldevent',
    ...params,
    page: {
      ...(params.page ? params.page : {}),
      extra: {
        type: 'details',
      },
    },
  });
}
